import { createStore } from 'vuex'
import services from "@/assets/data/services.json"
import equipo from "@/assets/data/equipo.json"
import testimonios from "@/assets/data/testimonios.json"

export default createStore({
  state: {
    clientLogos: [
      'agenciasost.png',
      'agricom.png',
      'anixter.jpg',
      'atika.png',
      'beka.png',
      'belive.png',
      'cavalieri.png',
      'chile_cargo.png',
      'clas.png',
      'clinica_udd.png',
      'club_palestino.png',
      'cmpc.png',
      'cph.png',
      'dhl.png',
      'duomo.png',
      'epson.png',
      'ergos.png',
      'ferrada.png',
      'fund_banigualdad.png',
      'fund_diabetes.png',
      'g4s.png',
      'gasco.png',
      'gbg.png',
      'guerrero.png',
      'initiative.png',
      'jv.png',
      'kupfer.png',
      'la_pizka.png',
      'michelin.png',
      'movitar_arena.png',
      'multicolor.png',
      'muni_lb.png',
      'pedroserrano.jpg',
      'price_forbes.png',
      'prymave.jpg',
      'sanfelipe.jpg',
      'sannicolas.jpg',
      'sanesteban.png',
      'softys.png',
      'telleria.png',
      'uchile.png',
      'udd.png',
      'um.png',
      'vma.jpg',
      'volcan.png'
    ],
    services: services,
    equipo: equipo,
    testimonios: testimonios,
  },
  getters: {
    getClientLogos: (state) => state.clientLogos,
    getServices: (state) => state.services,
    getEquipo: (state) => state.equipo,
    getTestimonios: (state) => state.testimonios,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
